import Box from "@mui/material/Box";
import Footer from "../footer/index.js";
import Header from "../header/index.js";

function BaseLayout({ children }) {
  return (
    <Box sx={{ width: "100%", minHeight: "100vh" }}>
      <Header />
      <Box
        sx={{
          p: 1,
          pb: "88px",
          maxWidth: 600,
          mx: "auto",
          width: "100%",
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
}

export default BaseLayout;
